import React from "react";
import PropTypes from "prop-types";
import { Box, Dialog, DialogContent } from "@mui/material";
import PrintTemplate from "react-print";
import LabelTemplate from "../../labelTemplate";

const PrintDialog = ({ open, popupData, onLabelRef }) => {
  return (
    <Box component="div" id="Print_Console_Label">
      <PrintTemplate>
        <Dialog
          open={open || false}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            sx: { borderRadius: "0px", width: "255px", height: "500px" },
          }}
        >
          <DialogContent sx={{ p: "10px" }}>
            <LabelTemplate
              style={{ display: "none" }}
              stockCode={(popupData && popupData.stock_code) || ""}
              pickupCode={(popupData && popupData.pucode) || ""}
              signature_url={popupData && popupData.signature_url}
              compactStockLabelLayout={true}
              rxNumbers={
                popupData &&
                popupData.items &&
                popupData.items.length > 0 &&
                popupData.items.map(({ rx_no }) => rx_no)
              }
              boxId={(popupData && popupData.box_id) || ""}
              boxDetails={Array.isArray(popupData && popupData.boxDetails) ? popupData.boxDetails : []}
              ref={(el) => onLabelRef && onLabelRef(el)}
              accountDetails={(popupData && popupData.accDetails) || ""}
              pharmacyDetails={(popupData && popupData.boxDetails) || ""}
              firstName={(popupData && popupData.first_name) || ""}
              lastName={(popupData && popupData.last_name) || ""}
              dateOfBirth={(popupData && popupData.dob_str) || ""}
              isCoolItem={(popupData && popupData.is_cool_item) || ""}
              prefer_location_name={(popupData && popupData.box_name) || ""}
              locationTypeID={(popupData && popupData.locationtype_id) || ""}
              brandingName={
                (popupData &&
                  popupData.accDetails &&
                  popupData.accDetails.brand &&
                  popupData.accDetails.brand.name) ||
                ""
              }
              brandingPhone={
                (popupData &&
                  popupData.accDetails &&
                  popupData.accDetails.brand &&
                  popupData.accDetails.brand.phone) ||
                ""
              }
            />
          </DialogContent>
        </Dialog>
      </PrintTemplate>
    </Box>
  );
};

PrintDialog.propTypes = {
  open: PropTypes.bool,
  popupData: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onLabelRef: PropTypes.func,
};

PrintDialog.defaultProps = {
  open: false,
  popupData: {},
  onLabelRef: undefined,
};

export default PrintDialog;





// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/counter/dialogs/PrintDialog.jsx